"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservablePromise = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Observable_1 = require("./Observable");
var ObservablePromise = /** @class */ (function () {
    function ObservablePromise(promise) {
        var _this = this;
        this._completed = new Observable_1.Observable(false);
        this._error = new Observable_1.Observable(undefined);
        this._completionTimeMs = new Observable_1.Observable(Number.MAX_SAFE_INTEGER);
        this._value = new Observable_1.Observable(undefined);
        this._promise = promise;
        this._promise.then(function (value) {
            _this._value.value = value;
            _this._complete();
        }, function (reason) {
            _this._error.value = reason;
            _this._complete();
        });
    }
    ObservablePromise.prototype._complete = function () {
        this._completed.value = true;
        this._completionTimeMs.value = Date.now();
    };
    Object.defineProperty(ObservablePromise.prototype, "completed", {
        get: function () {
            return this._completed.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePromise.prototype, "completionTimeMs", {
        get: function () {
            return this._completionTimeMs.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePromise.prototype, "value", {
        get: function () {
            return this._value.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePromise.prototype, "error", {
        get: function () {
            return this._error.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePromise.prototype, "promise", {
        get: function () {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    return ObservablePromise;
}());
exports.ObservablePromise = ObservablePromise;
//# sourceMappingURL=ObservablePromise.js.map